// extracted by mini-css-extract-plugin
module.exports = {"shortlistStar":"ShortlistStar_shortlistStar__Bgu_M","input":"ShortlistStar_input__HTXe8","rounded":"ShortlistStar_rounded__yEvHH"};